import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35e203ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = {
  key: 1,
  class: "center"
}
const _hoisted_3 = { class: "grid-container" }
const _hoisted_4 = {
  key: 0,
  class: "ma-3 text-green-500"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "d-flex flex-wrap justify-center ga-2" }
const _hoisted_7 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "d-flex flex-wrap justify-center ga-2" }
const _hoisted_11 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_12 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_13 = {
  key: 1,
  class: "ma-3"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "d-flex flex-wrap justify-center ga-2" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_19 = { class: "d-flex flex-wrap justify-center ga-2" }
const _hoisted_20 = {
  key: 3,
  class: "pa-2 text-left"
}
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-wrap align-center justify-end ga-1 mt-1"
}

import { compartirSistemaAleman } from "@/composables/useSistemaAleman";
import { compartirTorneoCerrado } from "@/composables/useTorneoCerrado";
import CardPartidaGestion from "@/components/GestionTorneos/CardPartidaGestion.vue";
import SelectorRondas from "@/components/Commons/SelectorRondas.vue";
import { useRondasEnPestana } from "@/composables/useRondasEnPestana";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import {
  getInfoTorneoEquipoCreado,
  guardarResultados,
} from "@/services/TorneosService";
import {
  ClasificacionEquipo,
  GuardarResultadosDTO,
  InscripcionTorneoCreadoDTO,
  ResultadoJugador,
} from "@/interfaces/Torneo";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import { Clasificacion, GenerarRonda, RequestUpdatePairingTorneoDTO } from "@/interfaces/Live";
import {
  ActualizarPairingEquiposDTO,
  PartidaTorneoDTO,
} from "@/interfaces/Partidas";
import { Torneo } from "@/interfaces/Torneo";
import { updatePairingTorneoAsync } from "@/services/PartidaTorneoService";
import {
  getPartidasTorneo,
  getTorneo,
  isSaveTournament,
} from "@/services/TorneosService";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalEliminarPartidaTorneo from "@/components/GestionTorneos/ModalEliminarPartidaTorneo.vue";
import ModalEliminarRondaTorneo from "@/components/GestionTorneos/ModalEliminarRondaTorneo.vue";
import { appsettings } from "@/settings/appsettings";
import ModalAgregarPairing from "@/components/GestionTorneos/ModalAgregarPairing.vue";
import { TorneoEquipoGestionInfoDTO } from "@/interfaces/Inscripcion";
import ModalParametrosRondasEquipo from "@/components/GestionTorneos/Equipos/ModalParametrosRondasEquipo.vue";
import CardGestionInfoTorneoEquipo from "@/components/GestionTorneos/Equipos/CardGestionInfoTorneoEquipo.vue";
import CardGestionAccionesTorneoEquipo from "@/components/GestionTorneos/Equipos/CardGestionAccionesTorneoEquipo.vue";
import CardInfoEquipo from "@/components/GestionTorneos/Equipos/CardInfoEquipo.vue";
import TabClasificacionEquipos from "@/components/GestionTorneos/Equipos/TabClasificacionEquipos.vue";
import TabClasificacionEquiposIndividual from "@/components/GestionTorneos/Equipos/TabClasificacionEquiposIndividual.vue";
import ModalCambiarPairingEquipoGestion from "@/components/PartidasTorneo/ModalCambiarPairingEquipoGestion.vue";
import CardEmparejamientosGestion from "@/components/GestionTorneos/Equipos/CardEmparejamientosGestion.vue";
import { getInscripcionesTorneo } from "@/services/InscripcionesService";
import {
  MatchResultGeneral,
  MatchResultPoint,
  ResultMatchMatchedPlayExtendedTeamType,
  ResultMatchMatchedPlayType,
} from "@/Constant/TipoClasificacion";
import { calcularPuntosAleman } from "@/utils/sistemaAleman";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleTorneoGestionEquiposView',
  setup(__props) {

const isLoadingImage = ref<boolean>(false);
const torneo = ref<Torneo>();
// Con el sistema alemán, las partidas enseñan también los puntos que dan
compartirSistemaAleman(() => torneo.value?.classificationType);
const partidas = ref<PartidaTorneoDTO[]>([]);
const numeroRondas = ref<number[]>([]);
const activeTab = ref<number>(0);
const partidasPorRonda = ref<Record<number, PartidaTorneoDTO[]>>({});
// La última ronda con partidas: la que se puede eliminar (ultimaRonda es la última del torneo, aunque no esté generada)
const ultimaRondaGenerada = computed(() =>
  Math.max(0, ...Object.keys(partidasPorRonda.value).map(Number))
);
const showErrorCambiarPairingModal = ref<boolean>(false);
const tabClasificacion = ref<number>();
const tabClasificacionIndividual = ref<number>();
const route = useRoute();
const idTorneo = ref<number>();
// Hasta tener el torneo no se pinta nada: así las pestañas se montan ya con sus valores
const isLoading = ref<boolean>(true);
const torneoGestion = ref<TorneoEquipoGestionInfoDTO | null>(null);
const clasificacion = ref<Clasificacion[]>([]);
const jugadoresZona1 = ref<Clasificacion[]>([]);
const jugadoresZona2 = ref<Clasificacion[]>([]);
const rondaAGenerar = ref<number>(0);
const showConfigModal = ref<boolean>(false);
const clasificacionDividida = ref<Clasificacion[]>([]);
const clasificacionZona1 = ref<Clasificacion[]>([]);
const clasificacionZona2 = ref<Clasificacion[]>([]);
const ultimaRonda = ref<number>();
const hasGanador = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const isGenerating = ref<boolean>(false);
const showModificarPairingModal = ref<boolean>(false);
const showAgregarPairingModal = ref<boolean>(false);
const showEliminarPartidaModal = ref<boolean>(false);
const showEliminarRondaModal = ref<boolean>(false);
const idRondaAEliminar = ref<number>(0);
const estaRondaUnoGenerada = ref<boolean>(false);
// Generar la ronda 1 y el sorteo están en la tarjeta de gestión; sus modales, en las acciones de los equipos
const accionesEquipo = ref<{ abrirGenerarRonda1: () => void; abrirSorteo: () => void }>();
const partidaActual = ref<PartidaTorneoDTO>({
  ejercitoUsuario1: null,
  ejercitoUsuario2: null,
  escenarioPartida: null,
  fechaPartida: "",
  ganadorPartidaTorneo: null,
  idPartidaTorneo: 0,
  idTorneo: 0,
  idUsuario1: 0,
  idUsuario2: 0,
  liderMuertoUsuario1: null,
  liderMuertoUsuario2: null,
  nick1: "",
  nick2: "",
  numeroRonda: 0,
  partidaValidadaUsuario1: null,
  partidaValidadaUsuario2: null,
  resultadoUsuario1: null,
  resultadoUsuario2: null,
  idEquipo1: null,
  idEquipo2: null,
  nombreEquipo1: null,
  nombreEquipo2: null,
  idCapitan1: null,
  idCapitan2: null,
  listasJugador1: null,
  listasJugador2: null,
  numeroMesa: null,
});
const idRondaSelected = ref<number>(0);
const wasSave = ref<boolean>(false);
// Cerrado, las tarjetas y tablas no enseñan lo que ya no se puede cambiar
compartirTorneoCerrado(wasSave);
const clasificacionEquipos = ref<ClasificacionEquipo[]>([]);
const inscripciones = ref<InscripcionTorneoCreadoDTO[]>([]);
const esParejas = computed(() => torneo.value?.tipoTorneo === "Parejas");

//Variables para el buscador
const busquedaEquipo = ref<string>("");
const equiposFiltrados = computed(() => {
  if (!torneoGestion.value) return [];
  return torneoGestion.value.equipos.filter(equipo =>
    (equipo.nombreEquipo?.toLowerCase() || "").includes(
      busquedaEquipo.value.toLowerCase()
    )
  );
});

function manejarClasificacion(clasificacion: ClasificacionEquipo[]) {
  clasificacionEquipos.value = clasificacion;
}

onMounted(async () => {
  idTorneo.value = parseInt(route.params.idTorneo.toString());

  isLoading.value = true;

  try {
    const responseTorneo = await getInfoTorneoEquipoCreado(idTorneo.value);
    torneoGestion.value = responseTorneo.data;
  } catch (error) {
    console.error(error);
    router.push({ name: "error" });
  }

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneo.value = responseTorneo.data;

    const responsePartidas = await getPartidasTorneo(idTorneo.value);
    partidas.value = responsePartidas.data;

    if (torneoGestion.value) {
      numeroRondas.value = Array.from(
        { length: torneoGestion.value.torneo.numeroPartidas },
        (_, index) => index + 1
      );
    }
    if (partidas.value) {
      partidasPorRonda.value = partidas.value.reduce(
        (acc, partida) => {
          const { numeroRonda } = partida;
          if (!acc[numeroRonda]) {
            acc[numeroRonda] = [];
          }
          acc[numeroRonda].push(partida);
          return acc;
        },
        {} as Record<number, PartidaTorneoDTO[]>
      );
    }

    if (partidas.value.length > 0) estaRondaUnoGenerada.value = true;

    tabClasificacion.value = numeroRondas.value.length + 1;
    tabClasificacionIndividual.value = numeroRondas.value.length + 2;

    try {
      const responseInscripciones = await getInscripcionesTorneo(
        idTorneo.value
      );
      inscripciones.value = responseInscripciones.data;
    } catch (error) {
      console.error(error);
    }

    calcularClasificacion();

    let ganador: number | null = null;
    ultimaRonda.value = numeroRondas.value.length;
    if (clasificacionZona1.value && clasificacionZona1.value.length > 0) {
      ganador = clasificacionZona1.value[0].idUsuario;
    }
    hasGanador.value = ganador !== null;

    ultimaRonda.value = numeroRondas.value.length;
    if (clasificacionZona1.value[0] != undefined) {
      ganador = clasificacionZona1.value[0].idUsuario;
    }
    if (ganador != null) hasGanador.value = true;

    const isSave = await isSaveTournament(idTorneo.value);
    wasSave.value = isSave.data;
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
});

const resultados = async (ronda: number) => {
  // Con lo último que hay en la página: una partida validada después de abrirla tiene que contar
  calcularClasificacion();
  try {
    isGenerating.value = true;
    // En Parejas va una fila por pareja con su capitán: el back pone al compañero en la misma posición
    const ganadores: ResultadoJugador[] = esParejas.value
      ? clasificacionEquipos.value
          .map((clasi, index) => {
            return {
              idUsuario:
                torneoGestion.value?.equipos.find(
                  e => e.idEquipo === clasi.idEquipo
                )?.idCapitan ?? 0,
              idTorneo: torneo.value?.idTorneo,
              resultado: index + 1,
            };
          })
          .filter(ganador => ganador.idUsuario !== 0)
      : clasificacion.value.map((clasi, index) => {
          return {
            idUsuario: clasi.idUsuario,
            idTorneo: torneo.value?.idTorneo,
            resultado: index + 1,
          };
        });
    const idTorneo: number | undefined = torneo.value?.idTorneo;

    if (idTorneo == undefined) return;

    const partidasUltimasRonda: GenerarRonda = {
      emparejamientos: [],
      luzVsOscCheck: false,
      mismaComunidadCheck: false,
      retosCheck: false,
      esEloCheck: false,
      opcionImpares: null,
      idTorneo: idTorneo,
      idRonda: ronda,
      isTorneoNarsil: false,
    };

    const guardarResultadosDTO: GuardarResultadosDTO = {
      ganadoresDTO: ganadores,
      generarRondaDTO: partidasUltimasRonda,
    };
    await guardarResultados(guardarResultadosDTO);
    wasSave.value = true;
    showSuccessModal.value = true;
  } catch (error) {
    showErrorModal.value = true;
    console.error(error);
  } finally {
    isGenerating.value = false;
  }
};

const closeConfigModal = () => {
  showConfigModal.value = false;
};

const handleConfigConfirm = () => {
  closeConfigModal();
};


// Los puntos extra que cambia el organizador mueven la clasificación al momento, sin recargar
const actualizarPuntosExtra = (idUsuario: number, puntosExtra: number) => {
  const inscripcion = inscripciones.value.find(i => i.idUsuario === idUsuario);
  if (inscripcion) inscripcion.puntosExtra = puntosExtra;
  calcularClasificacion();
};

const handleEquipoEliminado = (idEquipo: number) => {
  if (torneoGestion.value) {
    torneoGestion.value.equipos = torneoGestion.value.equipos.filter(
      e => e.idEquipo !== idEquipo
    );
  }
};



const closeAgregarPairingModal = () => {
  showAgregarPairingModal.value = false;
};

const closeEliminarPartidaModal = () => {
  showEliminarPartidaModal.value = false;
};

const handleEliminarPartidaConfirm = (idPartidaEliminada: number) => {
  try {
    partidas.value = partidas.value.filter(
      partida => partida.idPartidaTorneo !== idPartidaEliminada
    );
    partidasPorRonda.value = partidas.value.reduce(
      (acc, partida) => {
        const { numeroRonda } = partida;
        if (!acc[numeroRonda]) {
          acc[numeroRonda] = [];
        }
        acc[numeroRonda].push(partida);
        return acc;
      },
      {} as Record<number, PartidaTorneoDTO[]>
    );
    // El cambio mueve la clasificación
    calcularClasificacion();
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
    closeEliminarPartidaModal();
  }
};

// La tarjeta ya ha guardado el resultado o la validación: aquí solo se refleja. La respuesta puede venir sin nicks
const actualizarPartida = (actualizada: PartidaTorneoDTO) => {
  partidas.value = partidas.value.map(partida =>
    partida.idPartidaTorneo === actualizada.idPartidaTorneo
      ? {
          ...partida,
          ...actualizada,
          nick1: actualizada.nick1 ?? partida.nick1,
          nick2: actualizada.nick2 ?? partida.nick2,
        }
      : partida
  );
  partidasPorRonda.value = partidas.value.reduce(
    (acc, partida) => {
      const { numeroRonda } = partida;
      if (!acc[numeroRonda]) {
        acc[numeroRonda] = [];
      }
      acc[numeroRonda].push(partida);
      return acc;
    },
    {} as Record<number, PartidaTorneoDTO[]>
  );
  // El resultado mueve la clasificación
  calcularClasificacion();
};

const modificarPairing = (partidaRecibida: PartidaTorneoDTO) => {
  partidaActual.value = partidaRecibida;
  showModificarPairingModal.value = true;
};

const agregarPairing = (idRonda: number) => {
  idRondaSelected.value = idRonda;
  showAgregarPairingModal.value = true;
};

const eliminarPartida = (partidaRecibida: PartidaTorneoDTO) => {
  partidaActual.value = partidaRecibida;
  showEliminarPartidaModal.value = true;
};

const abrirEliminarRonda = (idRonda: number) => {
  idRondaAEliminar.value = idRonda;
  showEliminarRondaModal.value = true;
};

const closeEliminarRondaModal = () => {
  showEliminarRondaModal.value = false;
};

const handleEliminarRondaConfirm = (mensaje: string) => {
  partidas.value = partidas.value.filter(
    p => p.numeroRonda !== idRondaAEliminar.value
  );
  delete partidasPorRonda.value[idRondaAEliminar.value];
  showSuccessModal.value = true;
  console.info(mensaje);
};

const handleEliminarRondaError = (mensaje: string) => {
  showErrorModal.value = true;
  console.error(mensaje);
};

const generarSiguienteRonda = (ronda: number) => {
  try {
    rondaAGenerar.value = ronda;
    showConfigModal.value = true;
  } catch (error) {
    console.error("Error al generar la siguiente ronda:", error);
  }
};

const calcularClasificacion = () => {
  const ranking: Record<
    number,
    {
      nick: string;
      victorias: number;
      puntosFavor: number;
      puntosContra: number;
      diferenciaPuntos: number;
      lider: number;
      idUsuario: number;
      idTorneo: number;
      empates: number;
      derrotas: number;
      puntosTorneo: number;
    }
  > = {};
  const rankingDividido: Record<
    number,
    {
      nick: string;
      victorias: number;
      puntosFavor: number;
      puntosContra: number;
      diferenciaPuntos: number;
      lider: number;
      idUsuario: number;
      idTorneo: number;
      empates: number;
      derrotas: number;
      puntosTorneo: number;
    }
  > = {};

  // Filtramos hasta la ronda 2 para dividir el grupo
  const partidasFiltradas = partidas.value?.filter(
    partida => partida.numeroRonda <= 2
  );

  partidasFiltradas?.forEach(partida => {
    // Verifica que la partida esté validada por ambos usuarios
    if (partida.partidaValidadaUsuario1 && partida.partidaValidadaUsuario2) {
      const puntosUsuario1 = partida.resultadoUsuario1 ?? 0;
      const puntosUsuario2 = partida.resultadoUsuario2 ?? 0;
      const liderMuertoUsuario1 = partida.liderMuertoUsuario1 ? 1 : 0;
      const liderMuertoUsuario2 = partida.liderMuertoUsuario2 ? 1 : 0;

      // Inicializamos los jugadores si no están en el ranking
      if (!rankingDividido[partida.idUsuario1]) {
        rankingDividido[partida.idUsuario1] = {
          nick: partida.nick1,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario1,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }
      if (!rankingDividido[partida.idUsuario2]) {
        rankingDividido[partida.idUsuario2] = {
          nick: partida.nick2,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario2,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }

      // Actualizamos puntos a favor y en contra
      rankingDividido[partida.idUsuario1].puntosFavor += puntosUsuario1;
      rankingDividido[partida.idUsuario1].puntosContra += puntosUsuario2;
      rankingDividido[partida.idUsuario2].puntosFavor += puntosUsuario2;
      rankingDividido[partida.idUsuario2].puntosContra += puntosUsuario1;

      // Actualizamos la diferencia de puntos
      rankingDividido[partida.idUsuario1].diferenciaPuntos =
        rankingDividido[partida.idUsuario1].puntosFavor -
        rankingDividido[partida.idUsuario1].puntosContra;
      rankingDividido[partida.idUsuario2].diferenciaPuntos =
        rankingDividido[partida.idUsuario2].puntosFavor -
        rankingDividido[partida.idUsuario2].puntosContra;

      // Actualizamos las puntosTorneo
      if (torneo.value?.classificationType === 1) {
        //CLASIFICACION TIPO NORMAL
        if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
          rankingDividido[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          rankingDividido[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
          rankingDividido[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          rankingDividido[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          rankingDividido[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          rankingDividido[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          rankingDividido[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          rankingDividido[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
      } else if (torneo.value?.classificationType === 2) {
        //CLASIFICACION TIPO EXTENDED
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 === res2) {
          rankingDividido[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayExtendedTeamType.DRAW;
          rankingDividido[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayExtendedTeamType.DRAW;
          rankingDividido[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          rankingDividido[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        } else {
          if (res1 > res2) {
            if (res1 >= 2 * res2 && res1 >= 6) {
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_WIN;
              rankingDividido[partida.idUsuario1].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario2].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_LOSS;
            } else {
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_WIN;
              rankingDividido[partida.idUsuario1].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario2].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_LOSS;
            }
          }
          if (res2 > res1) {
            if (res2 >= 2 * res1 && res2 >= 6) {
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_WIN;
              rankingDividido[partida.idUsuario2].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario1].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_LOSS;
            } else {
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_WIN;
              rankingDividido[partida.idUsuario2].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario1].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_LOSS;
            }
          }
        }
      } else if (torneo.value?.classificationType === 3) {
        //CLASIFICACION TIPO ALEMAN
        // Sistema alemán: la suma de puntos de ambos jugadores es 20
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 > res2) {
          rankingDividido[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (res2 > res1) {
          rankingDividido[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          rankingDividido[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          rankingDividido[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
        const { jugador1, jugador2 } = calcularPuntosAleman(res1, res2);
        rankingDividido[partida.idUsuario1].puntosTorneo += jugador1;
        rankingDividido[partida.idUsuario2].puntosTorneo += jugador2;
      }

      // Lider muerto primero
      if (liderMuertoUsuario1) {
        rankingDividido[partida.idUsuario1].lider += MatchResultGeneral.DEAD;
      }
      if (liderMuertoUsuario2) {
        rankingDividido[partida.idUsuario2].lider += MatchResultGeneral.DEAD;
      }
    }
  });

  clasificacionDividida.value = Object.values(rankingDividido).sort((a, b) => {
    // 1. Ordenar por puntosTorneo
    if (b.puntosTorneo !== a.puntosTorneo) {
      return b.puntosTorneo - a.puntosTorneo;
    }
    // 2. Ordenar por diferencia de puntos (puntos a favor - puntos en contra)
    if (b.diferenciaPuntos !== a.diferenciaPuntos) {
      return b.diferenciaPuntos - a.diferenciaPuntos;
    }
    // 3. Ordenar por puntos a favor
    if (b.puntosFavor !== a.puntosFavor) {
      return b.puntosFavor - a.puntosFavor;
    }
    // 4. Ordenar por quién ha matado al líder primero
    return b.lider - a.lider;
  });

  dividirClasificacionEnZonas();

  // Clasificacion normal
  partidas.value?.forEach(partida => {
    // Verifica que la partida esté validada por ambos usuarios
    if (partida.partidaValidadaUsuario1 && partida.partidaValidadaUsuario2) {
      const puntosUsuario1 = partida.resultadoUsuario1 ?? 0;
      const puntosUsuario2 = partida.resultadoUsuario2 ?? 0;
      const liderMuertoUsuario1 = partida.liderMuertoUsuario1 ? 1 : 0;
      const liderMuertoUsuario2 = partida.liderMuertoUsuario2 ? 1 : 0;

      // Inicializamos los jugadores si no están en el ranking
      if (!ranking[partida.idUsuario1]) {
        ranking[partida.idUsuario1] = {
          nick: partida.nick1,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario1,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }
      if (!ranking[partida.idUsuario2]) {
        ranking[partida.idUsuario2] = {
          nick: partida.nick2,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario2,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }

      // Actualizamos puntos a favor y en contra
      ranking[partida.idUsuario1].puntosFavor += puntosUsuario1;
      ranking[partida.idUsuario1].puntosContra += puntosUsuario2;
      ranking[partida.idUsuario2].puntosFavor += puntosUsuario2;
      ranking[partida.idUsuario2].puntosContra += puntosUsuario1;

      // Actualizamos la diferencia de puntos
      ranking[partida.idUsuario1].diferenciaPuntos =
        ranking[partida.idUsuario1].puntosFavor -
        ranking[partida.idUsuario1].puntosContra;
      ranking[partida.idUsuario2].diferenciaPuntos =
        ranking[partida.idUsuario2].puntosFavor -
        ranking[partida.idUsuario2].puntosContra;

      // Actualizamos las puntosTorneo
      if (torneo.value?.classificationType === 1) {
        //CLASIFICACION TIPO NORMAL
        if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
          ranking[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
          ranking[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          ranking[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          ranking[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          ranking[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          ranking[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
      } else if (torneo.value?.classificationType === 2) {
        //CLASIFICACION TIPO EXTENDED
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 === res2) {
          ranking[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayExtendedTeamType.DRAW;
          ranking[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayExtendedTeamType.DRAW;
          ranking[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          ranking[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        } else {
          if (res1 > res2) {
            if (res1 >= 2 * res2 && res1 >= 6) {
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_WIN;
              ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_LOSS;
            } else {
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_WIN;
              ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_LOSS;
            }
          }
          if (res2 > res1) {
            if (res2 >= 2 * res1 && res2 >= 6) {
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_WIN;
              ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_LOSS;
            } else {
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_WIN;
              ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_LOSS;
            }
          }
        }
      } else if (torneo.value?.classificationType === 3) {
        //CLASIFICACION TIPO ALEMAN
        // Sistema alemán: la suma de puntos de ambos jugadores es 20
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 > res2) {
          ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (res2 > res1) {
          ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          ranking[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          ranking[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
        const { jugador1, jugador2 } = calcularPuntosAleman(res1, res2);
        ranking[partida.idUsuario1].puntosTorneo += jugador1;
        ranking[partida.idUsuario2].puntosTorneo += jugador2;
      }

      // Lider muerto primero
      if (liderMuertoUsuario1) {
        ranking[partida.idUsuario1].lider += MatchResultGeneral.DEAD;
      }
      if (liderMuertoUsuario2) {
        ranking[partida.idUsuario2].lider += MatchResultGeneral.DEAD;
      }
    }
  });

  inscripciones.value.forEach(inscripcion => {
    const userId = inscripcion.idUsuario;
    if (ranking[userId]) {
      ranking[userId].puntosTorneo += inscripcion.puntosExtra;
    }
  });

  clasificacion.value = Object.values(ranking).sort((a, b) => {
    // 1. Ordenar por puntosTorneo
    if (b.puntosTorneo !== a.puntosTorneo) {
      return b.puntosTorneo - a.puntosTorneo;
    }
    // 2. Ordenar por diferencia de puntos (puntos a favor - puntos en contra)
    if (b.diferenciaPuntos !== a.diferenciaPuntos) {
      return b.diferenciaPuntos - a.diferenciaPuntos;
    }
    // 3. Ordenar por puntos a favor
    if (b.puntosFavor !== a.puntosFavor) {
      return b.puntosFavor - a.puntosFavor;
    }
    // 4. Ordenar por quién ha matado al líder primero
    return b.lider - a.lider;
  });

  // Clasificacion por zonas
  clasificacionZona1.value = clasificacion.value.filter(jugador =>
    jugadoresZona1.value.some(z => z.idUsuario === jugador.idUsuario)
  );

  clasificacionZona2.value = clasificacion.value.filter(jugador =>
    jugadoresZona2.value.some(z => z.idUsuario === jugador.idUsuario)
  );

  type JugadorConEjercito = {
    nick: string;
    ejercito: string | null;
  };

  const jugadoresConEjercitos = partidas.value.reduce<JugadorConEjercito[]>(
    (acc, partida) => {
      // Solo las que tienen ejército: en la primera ronda puede faltar si aún no había entregado la lista
      if (partida.ejercitoUsuario1)
        acc.push({ nick: partida.nick1, ejercito: partida.ejercitoUsuario1 });
      if (partida.ejercitoUsuario2)
        acc.push({ nick: partida.nick2, ejercito: partida.ejercitoUsuario2 });
      return acc;
    },
    []
  );

  const listaEjercitos = appsettings.armies;

  const ejercitosJugadoresConBando = jugadoresConEjercitos.map(jugador => {
    const ejercito = listaEjercitos.find(e => e.name === jugador.ejercito);
    return {
      nick: jugador.nick,
      ejercito: jugador.ejercito,
      bando: ejercito ? ejercito.band : "desconocido",
      shortName: ejercito?.shortName,
    };
  });

  clasificacion.value = clasificacion.value.map(j => {
    const datosEjercito = ejercitosJugadoresConBando.find(
      e => e.nick === j.nick
    );
    return {
      ...j,
      bando: datosEjercito?.bando ?? "desconocido",
      nombreCortoEjercito: datosEjercito?.shortName ?? undefined,
      ejercito: datosEjercito?.ejercito ?? undefined,
    };
  });
};

const dividirClasificacionEnZonas = () => {
  const totalJugadores = clasificacionDividida.value.length;
  const esImpar = totalJugadores % 2 !== 0;

  const mitad = Math.floor(totalJugadores / 2);
  let zona1Size = esImpar ? mitad + 1 : mitad;
  if (zona1Size % 2 !== 0) zona1Size = zona1Size + 1;

  jugadoresZona1.value = clasificacionDividida.value.slice(0, zona1Size);
  jugadoresZona2.value = clasificacionDividida.value.slice(zona1Size);
};

const isRondaValidada = (numeroRonda: number) => {
  if (!partidasPorRonda.value[numeroRonda]) {
    return false;
  }

  return partidasPorRonda.value[numeroRonda].every(
    partida =>
      partida.partidaValidadaUsuario1 === true &&
      partida.partidaValidadaUsuario2 === true
  );
};













const sendUpdateBack = async (idJugador1: number, idJugador2: number) => {
  try {
    const body: RequestUpdatePairingTorneoDTO = {
      idPartidaTorneo: partidaActual.value.idPartidaTorneo,
      idUsuario1: idJugador1,
      idUsuario2: idJugador2,
    };
    const response = await updatePairingTorneoAsync(body);
    const index = partidas.value.findIndex(
      partida => partida.idPartidaTorneo === response.idPartidaTorneo
    );
    if (index !== -1) {
      partidas.value[index] = response;
    }
    partidasPorRonda.value = partidas.value.reduce(
      (acc, partida) => {
        const { numeroRonda } = partida;
        if (!acc[numeroRonda]) {
          acc[numeroRonda] = [];
        }
        acc[numeroRonda].push(partida);
        return acc;
      },
      {} as Record<number, PartidaTorneoDTO[]>
    );
    showSuccessModal.value = true;
    return true;
  } catch (error) {
    console.error(error);
    showErrorCambiarPairingModal.value = true;
    return false;
  }
};

const actualizarPairing = async (payload: ActualizarPairingEquiposDTO) => {
  isGenerating.value = true;
  const isUpdate: boolean = await sendUpdateBack(
    payload.idJugador1,
    payload.idJugador2
  );

  if (isUpdate) {
    partidaActual.value.idUsuario1 = payload.idJugador1;
    partidaActual.value.idUsuario2 = payload.idJugador2;
    partidaActual.value.ejercitoUsuario1 = payload.ejercitoEquipo1;
    partidaActual.value.ejercitoUsuario2 = payload.ejercitoEquipo2;
    partidaActual.value.nick1 = payload.nick1;
    partidaActual.value.nick2 = payload.nick2;
  }
  showModificarPairingModal.value = false;
  isGenerating.value = false;
};

// Las rondas en una sola pestaña: activeTab sigue siendo el número de ronda
const {
  pestana,
  enRondas,
  TAB_RONDAS,
  jugadorBuscado,
  jugadores,
  deLaBusqueda,
  equiposDelBuscado,
  mesaDe,
} = useRondasEnPestana(
  activeTab,
  numeroRondas,
  partidasPorRonda
);

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "text-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "12",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(LoadingGandalf)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_card, {
                      class: "mx-auto",
                      "max-width": "800"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tabs, {
                          modelValue: _unref(pestana),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(pestana) ? (pestana).value = $event : null)),
                          grow: "",
                          "center-active": "",
                          "fixed-tabs": ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_v_tab, {
                              key: 0,
                              text: `Gestión`,
                              value: 0
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Gestión")
                              ]),
                              _: 1
                            })),
                            _createVNode(_component_v_tab, {
                              value: _unref(TAB_RONDAS),
                              text: "Rondas"
                            }, null, 8, ["value"]),
                            (_openBlock(), _createBlock(_component_v_tab, {
                              key: tabClasificacion.value,
                              text: `Clasificación`,
                              value: tabClasificacion.value
                            }, null, 8, ["value"])),
                            (torneo.value?.tipoTorneo !== 'Parejas')
                              ? (_openBlock(), _createBlock(_component_v_tab, {
                                  key: tabClasificacionIndividual.value,
                                  text: "Individual",
                                  value: tabClasificacionIndividual.value
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_unref(enRondas))
                          ? (_openBlock(), _createBlock(SelectorRondas, {
                              key: 0,
                              modelValue: activeTab.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
                              rondas: numeroRondas.value,
                              partidasPorRonda: partidasPorRonda.value,
                              jugador: _unref(jugadorBuscado),
                              "onUpdate:jugador": _cache[2] || (_cache[2] = ($event: any) => (_isRef(jugadorBuscado) ? (jugadorBuscado).value = $event : null)),
                              jugadores: _unref(jugadores)
                            }, null, 8, ["modelValue", "rondas", "partidasPorRonda", "jugador", "jugadores"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_window, {
                          modelValue: _unref(pestana),
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(pestana) ? (pestana).value = $event : null))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_v_window_item, {
                              value: 0,
                              key: 0
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(CardGestionInfoTorneoEquipo, { torneo: torneoGestion.value }, {
                                    acciones: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            variant: "tonal",
                                            color: "primary",
                                            block: "",
                                            disabled: estaRondaUnoGenerada.value,
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (accionesEquipo.value?.abrirGenerarRonda1()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Generar ronda 1 ")
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            variant: "tonal",
                                            color: "primary",
                                            block: "",
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (accionesEquipo.value?.abrirSorteo()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Sorteo ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["torneo"]),
                                  _createVNode(CardGestionAccionesTorneoEquipo, {
                                    ref_key: "accionesEquipo",
                                    ref: accionesEquipo,
                                    torneo: torneoGestion.value,
                                    rondaGenerada: estaRondaUnoGenerada.value
                                  }, null, 8, ["torneo", "rondaGenerada"]),
                                  _createVNode(_component_v_text_field, {
                                    modelValue: busquedaEquipo.value,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((busquedaEquipo).value = $event)),
                                    label: "Buscar equipo por nombre",
                                    "prepend-inner-icon": "mdi-magnify",
                                    class: "ma-4",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_3, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equiposFiltrados.value, (equipo) => {
                                      return (_openBlock(), _createBlock(CardInfoEquipo, {
                                        key: equipo.idEquipo,
                                        equipo: equipo,
                                        torneo: torneo.value!,
                                        onDeleteTeam: ($event: any) => (handleEquipoEliminado(equipo.idEquipo)),
                                        onPuntosExtra: actualizarPuntosExtra
                                      }, null, 8, ["equipo", "torneo", "onDeleteTeam"]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _: 1
                            })),
                            (isRondaValidada(activeTab.value))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  _createTextVNode(" Todas las partidas están validadas "),
                                  (!wasSave.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createVNode(_component_v_list_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_content, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_6, [
                                                      (!esParejas.value)
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 0,
                                                            class: "mt-2",
                                                            variant: "tonal",
                                                            color: "secondary",
                                                            onClick: _cache[6] || (_cache[6] = ($event: any) => (agregarPairing(activeTab.value)))
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" Añadir partida ")
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  (ultimaRonda.value != activeTab.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        (partidasPorRonda.value[activeTab.value + 1] != undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " La ronda " + _toDisplayString(activeTab.value + 1) + " ya se ha generado ", 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_content, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_10, [
                                                            _createVNode(_component_v_btn, {
                                                              class: "mt-2",
                                                              variant: "tonal",
                                                              color: "primary",
                                                              onClick: _cache[7] || (_cache[7] = ($event: any) => (generarSiguienteRonda(activeTab.value + 1)))
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(" Generar siguiente ronda ")
                                                              ]),
                                                              _: 1
                                                            }),
                                                            (activeTab.value === ultimaRondaGenerada.value && !wasSave.value)
                                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                  key: 0,
                                                                  class: "mt-2",
                                                                  variant: "tonal",
                                                                  color: "error",
                                                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (abrirEliminarRonda(activeTab.value)))
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(" Eliminar ronda ")
                                                                  ]),
                                                                  _: 1
                                                                }))
                                                              : _createCommentVNode("", true)
                                                          ])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        (wasSave.value)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Resultados guardados: el torneo está cerrado."))
                                          : _createCommentVNode("", true),
                                        (hasGanador.value && !wasSave.value)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              class: "mt-2",
                                              variant: "tonal",
                                              color: "primary",
                                              onClick: _cache[9] || (_cache[9] = ($event: any) => (resultados(activeTab.value)))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Guardar resultados ")
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (!wasSave.value)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 2,
                                              class: "mt-2 ml-2",
                                              variant: "tonal",
                                              color: "error",
                                              onClick: _cache[10] || (_cache[10] = ($event: any) => (abrirEliminarRonda(activeTab.value)))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Eliminar ronda ")
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  (
                    !partidasPorRonda.value[activeTab.value] && _unref(enRondas)
                  )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createTextVNode(" Esperando ronda... "),
                                        (!wasSave.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_content, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_16, [
                                                            (!esParejas.value)
                                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                  key: 0,
                                                                  class: "mt-2",
                                                                  variant: "tonal",
                                                                  color: "secondary",
                                                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (agregarPairing(activeTab.value)))
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(" Añadir partida ")
                                                                  ]),
                                                                  _: 1
                                                                }))
                                                              : _createCommentVNode("", true)
                                                          ])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        (partidasPorRonda.value[activeTab.value])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                              _createTextVNode(" Faltan partidas por validar "),
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_v_list_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_content, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_19, [
                                                              (!esParejas.value && !wasSave.value)
                                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                    key: 0,
                                                                    class: "mt-2",
                                                                    variant: "tonal",
                                                                    color: "secondary",
                                                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (agregarPairing(activeTab.value)))
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(" Añadir partida ")
                                                                    ]),
                                                                    _: 1
                                                                  }))
                                                                : _createCommentVNode("", true),
                                                              (activeTab.value === ultimaRondaGenerada.value && !wasSave.value)
                                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                    key: 1,
                                                                    class: "mt-2",
                                                                    variant: "tonal",
                                                                    color: "error",
                                                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (abrirEliminarRonda(activeTab.value)))
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(" Eliminar ronda ")
                                                                    ]),
                                                                    _: 1
                                                                  }))
                                                                : _createCommentVNode("", true)
                                                            ])
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                ])),
                            (_unref(enRondas) && torneo.value?.tipoTorneo !== 'Individual')
                              ? (_openBlock(), _createBlock(CardEmparejamientosGestion, {
                                  key: 2,
                                  partidas: partidas.value,
                                  soloEquipos: _unref(equiposDelBuscado),
                                  cerrado: wasSave.value,
                                  numeroRonda: activeTab.value,
                                  idTorneo: parseInt(_unref(route).params.idTorneo.toString())
                                }, null, 8, ["partidas", "soloEquipos", "cerrado", "numeroRonda", "idTorneo"]))
                              : _createCommentVNode("", true),
                            (partidasPorRonda.value[activeTab.value!]?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deLaBusqueda)(partidasPorRonda.value[activeTab.value!]), (partida) => {
                                    return (_openBlock(), _createBlock(CardPartidaGestion, {
                                      key: partida.idPartidaTorneo,
                                      partida: partida,
                                      editable: true,
                                      etiqueta: `Mesa ${_unref(mesaDe)(partidasPorRonda.value[activeTab.value!], partida)}`,
                                      listaPorPareja: torneo.value?.listaPorPareja,
                                      onPartidaActualizada: actualizarPartida
                                    }, {
                                      default: _withCtx(() => [
                                        (!wasSave.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                              _createVNode(_component_v_btn, {
                                                size: "small",
                                                variant: "text",
                                                "prepend-icon": "mdi-swap-horizontal",
                                                onClick: ($event: any) => (modificarPairing(partida))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Cambiar emparejamiento ")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]),
                                              _createVNode(_component_v_btn, {
                                                size: "small",
                                                variant: "text",
                                                color: "error",
                                                icon: "mdi-delete",
                                                "aria-label": "Eliminar partida",
                                                title: "Eliminar partida",
                                                onClick: ($event: any) => (eliminarPartida(partida))
                                              }, null, 8, ["onClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["partida", "etiqueta", "listaPorPareja"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(TabClasificacionEquipos, {
                              tabClasificacion: tabClasificacion.value,
                              activeTab: activeTab.value,
                              torneo: torneo.value,
                              partidas: partidas.value,
                              equipos: torneoGestion.value?.equipos,
                              onEnviarClasificacion: manejarClasificacion
                            }, null, 8, ["tabClasificacion", "activeTab", "torneo", "partidas", "equipos"]),
                            _createVNode(TabClasificacionEquiposIndividual, {
                              tabClasificacion: tabClasificacionIndividual.value,
                              activeTab: activeTab.value,
                              clasificacion: clasificacion.value,
                              mostrarClasificacion: true
                            }, null, 8, ["tabClasificacion", "activeTab", "clasificacion"]),
                            _createVNode(_component_v_window_item, { value: _unref(TAB_RONDAS) }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: isLoadingImage.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isLoadingImage).value = $event)),
        persistent: "",
        width: "300"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, {
                class: "d-flex justify-center align-center",
                style: {"height":"150px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "blue-lighten-3",
                    size: 57
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(ModalParametrosRondasEquipo, {
        isVisible: showConfigModal.value,
        torneo: torneoGestion.value,
        clasificacion: clasificacionEquipos.value,
        ronda: rondaAGenerar.value,
        partidas: partidas.value,
        onClose: closeConfigModal,
        onConfirm: handleConfigConfirm
      }, null, 8, ["isVisible", "torneo", "clasificacion", "ronda", "partidas"]),
      _createVNode(ModalCambiarPairingEquipoGestion, {
        isVisible: showModificarPairingModal.value,
        idEquipo1: partidaActual.value.idEquipo1!,
        idEquipo2: partidaActual.value.idEquipo2!,
        nombreEquipo1: partidaActual.value.nombreEquipo1!,
        nombreEquipo2: partidaActual.value.nombreEquipo2!,
        partida: partidaActual.value,
        onActualizar: actualizarPairing,
        onCerrar: _cache[16] || (_cache[16] = ($event: any) => (showModificarPairingModal.value = false))
      }, null, 8, ["isVisible", "idEquipo1", "idEquipo2", "nombreEquipo1", "nombreEquipo2", "partida"]),
      _createVNode(ModalAgregarPairing, {
        isVisible: showAgregarPairingModal.value,
        idTorneo: idTorneo.value!,
        idRonda: idRondaSelected.value,
        onCerrar: closeAgregarPairingModal
      }, null, 8, ["isVisible", "idTorneo", "idRonda"]),
      _createVNode(ModalEliminarPartidaTorneo, {
        isVisible: showEliminarPartidaModal.value,
        partida: partidaActual.value,
        onCerrar: closeEliminarPartidaModal,
        onConfirm: handleEliminarPartidaConfirm
      }, null, 8, ["isVisible", "partida"]),
      (idTorneo.value)
        ? (_openBlock(), _createBlock(ModalEliminarRondaTorneo, {
            key: 0,
            isVisible: showEliminarRondaModal.value,
            idTorneo: idTorneo.value,
            idRonda: idRondaAEliminar.value,
            onCerrar: closeEliminarRondaModal,
            onConfirm: handleEliminarRondaConfirm,
            onError: handleEliminarRondaError
          }, null, 8, ["isVisible", "idTorneo", "idRonda"]))
        : _createCommentVNode("", true),
      _createVNode(ModalSuccess, {
        isVisible: showSuccessModal.value,
        message: "Acción realizada correctamente.",
        "onUpdate:isVisible": _cache[17] || (_cache[17] = ($event: any) => (showSuccessModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(ModalError, {
        isVisible: showErrorModal.value,
        message: "No se han podido guardar los resultados. Intentalo de nuevo y si el error persiste contacta con el administrador.",
        "onUpdate:isVisible": _cache[18] || (_cache[18] = ($event: any) => (showErrorModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(ModalError, {
        isVisible: showErrorCambiarPairingModal.value,
        message: "Ha ocurrido un error al cambiar el emparejamiento. Inténtalo de nuevo o contacta al administrador del torneo.",
        "onUpdate:isVisible": _cache[19] || (_cache[19] = ($event: any) => (showErrorCambiarPairingModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(_component_v_dialog, {
        modelValue: isGenerating.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((isGenerating).value = $event)),
        "hide-overlay": "",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "progress-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "70"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})